import OpenApiWireAdapter from "./adapter";
import authManager from "./authManager";

function createWireAdapter(defaultMethod = 'GET', defaultConfig = {}) {
  function wireAdapterFunction(configOrDataCallback) {
    if (typeof configOrDataCallback === 'function') {
      const adapter = new OpenApiWireAdapter(configOrDataCallback);

      const originalUpdate = adapter.update.bind(adapter);
      adapter.update = function (config) {
        const fullConfig = {
          endpoint: getEndpoint(config),
          method: defaultMethod,
          ...defaultConfig,
          ...config
        }
        delete fullConfig.endpointConfig;

        if (config && typeof config === 'object' && !config.endpoint) {
          fullConfig.params = config.params || config;
        }

        return originalUpdate(fullConfig);
      }
      return adapter;
    } else {
      const config = configOrDataCallback || {};
      return createPromiseCall(defaultMethod, defaultConfig, config);
    }
    
  }
  return wireAdapterFunction;
}

// 创建 Promise 调用的辅助函数
async function createPromiseCall(defaultMethod, defaultConfig, config) {
  // 等待认证完成
  await authManager.waitForAuth();

  // 合并默认配置和传入的配置
  const fullConfig = {
    endpoint: getEndpoint(config),
    method: defaultMethod,
    ...defaultConfig,
    ...config
  }
  delete fullConfig.endpointConfig;

  // 如果传入的是 params，直接使用
  if (config && typeof config === 'object' && !config.endpoint) {
    fullConfig.params = config.params || config;
  }

  return new Promise((resolve, reject) => {
    const adapter = new OpenApiWireAdapter((result) => {
      if (result.error) {
        reject(result.error);
      } else {
        resolve(result);
      }
    });

    // 连接并更新配置
    adapter.connect();
    adapter.update(fullConfig);
  });
}

function getEndpoint(config) { 
  if (!config || !config.endpointConfig) {
    throw new Error('No config provided');
  }

  const { endpointConfig } = config;
  if (typeof endpointConfig === 'string') return config;
  if (endpointConfig.endpoint) return endpointConfig.endpoint;
  if (!endpointConfig.isv) {
    throw new Error('Invalid config isv provided');
  }

  if (!endpointConfig.app) {
    throw new Error('Invalid config app provided');
  }

  if (!endpointConfig.form) {
    throw new Error('Invalid config form provided');
  }

  if (!endpointConfig.serviceName) {
    throw new Error('Invalid config serviceName provided');
  }

  return `/kapi/${endpointConfig.version || 'v2'}/${endpointConfig.isv}/${endpointConfig.app}/${endpointConfig.form}/${endpointConfig.serviceName}`
}

export const doFetch = createWireAdapter('POST')
